"use client";
import React, { useEffect, useMemo } from "react";
import "./index.css"
import FullBlogSection from "./FullBlogSection";
import RelatedContent from "./RelatedContent";
import FaqSection from "@/components/common-components/faqs/FaqSection";
import PageTitle from "@/components/common-components/page-title/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchBlogDetails,
  fetchRecentBlogs,
  // fetchTags,
} from "@/redux/blogsSlice";

const ORG_KEY = process.env.NEXT_PUBLIC_ORGANIZATION_KEY;

const BlogDetails = ({ blogDetails }) => {
  const dispatch = useDispatch();
  const recentBlogs = useSelector((state) => state.blogs.recentBlogs);
  const blogDetailsRedux = useSelector((state) => state.blogs.blogDetails);
  const detailsStatus = useSelector((state) => state.blogs.detailsStatus);
  const recentStatus = useSelector((state) => state.blogs.recentStatus);

  useEffect(() => {
    // Only fetch if details are missing or for a different blog
    if (detailsStatus === 'idle' || (blogDetails?.id && blogDetailsRedux?.id !== blogDetails?.id)) {
      dispatch(
        fetchBlogDetails({
          payload: {
            organization_key: ORG_KEY,
            slug: blogDetails?.blog_slug,
          },
        })
      );
    }
  }, [dispatch, blogDetails?.blog_slug, blogDetails?.id, detailsStatus, blogDetailsRedux?.id]);

  const recentBlogsPayload = useMemo(() => {
    return {
      organization_key: ORG_KEY,
      limit: 3,
      blog_id: blogDetails?.id, // Skip current blog ID in recent list
    };
  }, [blogDetails?.id]);

  useEffect(() => {
    // Fetch recent blogs if idle or if the exclude ID has changed (navigation)
    if (recentStatus === 'idle' || (blogDetails?.id && recentBlogsPayload.blog_id !== blogDetailsRedux?.id)) {
      dispatch(fetchRecentBlogs({ payload: recentBlogsPayload }));
    }
  }, [dispatch, recentBlogsPayload, recentStatus, blogDetails?.id, blogDetailsRedux?.id]);

  const blogSchema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": blogDetails?.blog_title,
    "image": [blogDetails?.blog_image],
    "datePublished": blogDetails?.created_at,
    "author": [{
      "@type": "Organization",
      "name": "The Dentofacial Hub",
      "url": process.env.NEXT_PUBLIC_BASE_URL
    }]
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(blogSchema) }}
      />
      <PageTitle
        image={"/images/blog-detail-bg.webp"}
        type="blog"
        name={blogDetails?.blog_title || "blog details"}
        link={"/blog"}

      />
      <FullBlogSection blogDetails={blogDetails} recentBlogs={recentBlogs} />
      <RelatedContent recentBlogs={recentBlogs} />
      <FaqSection />
    </>
  );
};

export default BlogDetails;
